import Card from '../../components/Card';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';
import { useT } from '../../utils/useTranslation';
import api, { DB_TYPE } from '../../api';
import { db, auth } from '../../firebase';
import { getCountFromServer, collection, query, where, getDocs, orderBy, limit, doc, getDoc } from 'firebase/firestore';
import { updatePassword } from 'firebase/auth';
import { motion } from 'framer-motion';
const StatCard = ({
  icon,
  label,
  value,
  color,
  to,
  badge,
  gradient
}) => <motion.div whileHover={{
  y: -8,
  transition: {
    duration: 0.2,
    ease: 'easeOut'
  }
}} initial={{
  opacity: 0,
  y: 20
}} animate={{
  opacity: 1,
  y: 0
}}>
    <Link to={to || '#'} style={{
    textDecoration: 'none'
  }}>
      <Card style={{
      overflow: 'hidden',
      cursor: 'pointer',
      border: '1px solid var(--sindhi-cream)',
      background: 'white',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '28px'
    }}>
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
          <div>
            <div style={{
            fontSize: 13,
            color: 'var(--sindhi-text-muted)',
            marginBottom: 8,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: 0.5
          }}>{label}</div>
            <div style={{
            fontSize: 36,
            fontWeight: 800,
            fontFamily: 'var(--font-display)',
            color: 'var(--sindhi-navy)',
            letterSpacing: -1
          }}>{value}</div>
            {badge > 0 && <div style={{
            fontSize: 11,
            color: 'var(--sindhi-maroon)',
            marginTop: 8,
            fontWeight: 800,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            background: 'var(--sindhi-ivory)',
            padding: '2px 8px',
            borderRadius: 6,
            width: 'fit-content'
          }}>
                <span style={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              background: 'var(--sindhi-maroon)',
              boxShadow: '0 0 8px var(--sindhi-maroon)'
            }} />
                {badge} {t('pendingLabel')}
              </div>}
          </div>
          <div style={{
          fontSize: 28,
          background: gradient || `${color}15`,
          width: 60,
          height: 60,
          borderRadius: 16,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: gradient ? '0 8px 20px -6px rgba(0,0,0,0.15)' : 'none'
        }}>{icon}</div>
        </div>
      </Card>
    </Link>
  </motion.div>;
const QuickAction = ({
  icon,
  label,
  to,
  color,
  index
}) => <Link to={to} style={{
  textDecoration: 'none'
}}>
    <motion.div initial={{
    opacity: 0,
    x: -10
  }} animate={{
    opacity: 1,
    x: 0
  }} transition={{
    delay: index * 0.05
  }} whileHover={{
    x: 8,
    background: 'var(--sindhi-ivory)',
    borderColor: 'var(--sindhi-gold-muted)',
    transition: {
      duration: 0.2
    }
  }} style={{
    padding: '18px 24px',
    borderRadius: 16,
    background: 'white',
    border: '1px solid var(--sindhi-cream)',
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    cursor: 'pointer',
    transition: 'all 0.2s'
  }}>
      <span style={{
      fontSize: 20,
      width: 40,
      height: 40,
      background: 'var(--sindhi-ivory)',
      borderRadius: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>{icon}</span>
      <span style={{
      fontSize: 15,
      fontWeight: 700,
      color: 'var(--sindhi-navy)'
    }}>{label}</span>
      <span style={{
      marginLeft: 'auto',
      color: 'var(--sindhi-maroon)',
      fontSize: 18,
      fontWeight: 800
    }}>→</span>
    </motion.div>
  </Link>;
export default function Dashboard() {
  const {
    user
  } = useAuth();
  const t = useT();
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [memberData, setMemberData] = useState(null);
  const [branchEvents, setBranchEvents] = useState([]);

  useEffect(() => {
    if (DB_TYPE === 'firebase') {
      const loadDashboard = async () => {
        try {
          const isMain = user?.role === 'main_admin';
          const branchId = user?.branchId;

          let memberQuery = collection(db, 'members');
          let pendingMemberQuery = query(collection(db, 'members'), where('status', '==', 'pending'));
          let bookQuery = collection(db, 'published_books');
          let eventQuery = collection(db, 'events');
          
          if (user?.role === 'district_coordinator' && user?.districtId) {
            const branchesSnap = await getDocs(query(collection(db, 'branches'), where('districtId', '==', user.districtId), where('status', '==', 'active')));
            const activeBranchIds = branchesSnap.docs.map(d => d.id);
            
            if (activeBranchIds.length > 0 && activeBranchIds.length <= 30) {
              memberQuery = query(collection(db, 'members'), where('current_branch_id', 'in', activeBranchIds), where('status', '==', 'approved'));
              pendingMemberQuery = query(collection(db, 'members'), where('current_branch_id', 'in', activeBranchIds), where('status', '==', 'pending'));
            } else if (activeBranchIds.length > 30) {
              memberQuery = query(collection(db, 'members'), where('districtId', '==', user.districtId), where('status', '==', 'approved'));
              pendingMemberQuery = query(collection(db, 'members'), where('districtId', '==', user.districtId), where('status', '==', 'pending'));
            } else {
              memberQuery = query(collection(db, 'members'), where('current_branch_id', '==', 'NONE'));
              pendingMemberQuery = query(collection(db, 'members'), where('current_branch_id', '==', 'NONE'));
            }
          } else if (branchId && !isMain) {
            memberQuery = query(collection(db, 'members'), where('current_branch_id', '==', branchId), where('status', '==', 'approved'));
            pendingMemberQuery = query(collection(db, 'members'), where('current_branch_id', '==', branchId), where('status', '==', 'pending'));
            bookQuery = query(collection(db, 'published_books'), where('branchId', '==', branchId));
            eventQuery = query(collection(db, 'events'), where('branch', '==', branchId));
          } else if (isMain) {
             memberQuery = query(collection(db, 'members'), where('status', '==', 'approved'));
          }

          const [m, b, bk, e, pm] = await Promise.all([
            getCountFromServer(memberQuery),
            getCountFromServer(collection(db, 'branches')),
            getCountFromServer(bookQuery),
            getCountFromServer(eventQuery),
            getCountFromServer(pendingMemberQuery)
          ]);

          setStats({
            totalMembers: m.data().count,
            totalBranches: b.data().count,
            totalBooks: bk.data().count,
            totalEvents: e.data().count,
            pendingMembers: pm.data().count
          });

          // Fetch member data if role is member
          if (user?.role === 'member' && user?.memberId) {
            const mDoc = await getDoc(doc(db, 'members', user.memberId));
            if (mDoc.exists()) setMemberData(mDoc.data());
          }

          // Fetch branch activity if branchId exists
          if (user?.branchId) {
            const q = query(collection(db, 'events'), where('branch', '==', user.branchId), orderBy('date', 'desc'), limit(5));
            const snap = await getDocs(q);
            setBranchEvents(snap.docs.map(d => ({ id: d.id, ...d.data() })));
          }

        } catch (err) { console.error(err); }
        finally { setLoading(false); }
      };
      loadDashboard();
    } else {
      api.get('/dashboard/stats').then(r => {
        setStats(r.data);
        setLoading(false);
      }).catch(() => setLoading(false));
    }
  }, [user]);
  const isMember = user?.role === 'member';
  const isMain = user?.role === 'main_admin';
  const hour = new Date().getHours();
  const greeting = hour < 12 ? t('goodMorning') : hour < 17 ? t('goodAfternoon') : t('goodEvening');
  return <div className="fade-in">
      {/* Welcome */}
      {/* Welcome Section */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} animate={{
      opacity: 1,
      scale: 1
    }} style={{
      background: 'linear-gradient(135deg, #0f172a, #1e293b)',
      borderRadius: 32,
      padding: '48px',
      marginBottom: 40,
      color: 'white',
      position: 'relative',
      overflow: 'hidden',
      boxShadow: '0 30px 60px -15px rgba(15, 23, 42, 0.3)'
    }}>
        {/* Subtle Ajrak-like pattern overlay */}
        <div style={{
        position: 'absolute',
        inset: 0,
        opacity: 0.05,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4v-4H4v4H0v2h4v4h2v-4h4v-2H6zm30 0v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundSize: '40px 40px'
      }} />
        
        <div style={{
        position: 'relative',
        zIndex: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
          <div>
            <div style={{
            fontSize: 16,
            color: 'var(--sindhi-gold)',
            marginBottom: 12,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: 2
          }}>{greeting}</div>
            <h1 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 44,
            fontWeight: 800,
            marginBottom: 12,
            letterSpacing: -1.5
          }}>
              {t('hello')}, {user?.name} <span style={{
              display: 'inline-block',
              animation: 'wave 2s infinite'
            }}>👋</span>
            </h1>
            <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 16
          }}>
              <span style={{
              fontSize: 12,
              background: 'rgba(255,255,255,0.1)',
              color: 'white',
              padding: '6px 16px',
              borderRadius: 100,
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: 1,
              border: '1px solid rgba(255,255,255,0.1)'
            }}>
                {user?.role?.replace('_', ' ')}
              </span>
              {user?.recovery_key && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(212, 175, 55, 0.1)', border: '1px solid rgba(212, 175, 55, 0.3)', padding: '6px 16px', borderRadius: 100 }}>
                      <span style={{ fontSize: 10, color: 'var(--sindhi-gold)', fontWeight: 800, textTransform: 'uppercase' }}>{t('recoveryKey')}:</span>
                      <span style={{ fontSize: 12, color: 'white', fontWeight: 700, fontFamily: 'monospace' }}>{user.recovery_key}</span>
                      <button onClick={() => { navigator.clipboard.writeText(user.recovery_key); toast.success('Copied!'); }} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', padding: 0, display: 'flex' }}>📋</button>
                  </div>
              )}
              <span style={{
              fontSize: 14,
              color: 'rgba(255,255,255,0.5)',
              fontWeight: 600
            }}>{t('welcomeTitle')}</span>
            </div>
          </div>
          <div style={{
          display: 'none'
        }}>
            {/* Can put a large icon or logo here if needed */}
          </div>
        </div>
      </motion.div>

      {/* Stats grid */}
      {loading ? <div style={{
      display: 'flex',
      justifyContent: 'center',
      padding: 60
    }}>
          <div className="spinner" />
        </div> : <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
      gap: 24,
      marginBottom: 40
    }}>
          <StatCard icon="👥" label={t('totalMembers')} value={stats.totalMembers ?? 0} color="#e11d48" gradient="linear-gradient(135deg, #fff1f2, #ffe4e6)" to="/admin/members" badge={stats.pendingMembers} />
          {isMain && <StatCard icon="🌿" label={t('activeBranches')} value={stats.totalBranches ?? 0} color="#d97706" gradient="linear-gradient(135deg, #fffbeb, #fef3c7)" to="/admin/branches" badge={stats.pendingBranches} />}
          <StatCard icon="📚" label={t('booksJournals')} value={stats.totalBooks ?? 0} color="#2563eb" gradient="linear-gradient(135deg, #eff6ff, #dbeafe)" to="/admin/books" />
          <StatCard icon="📅" label={t('eventsNews')} value={stats.totalEvents ?? 0} color="#7c3aed" gradient="linear-gradient(135deg, #f5f3ff, #ede9fe)" to="/admin/events" />
        </div>}
      
      {loading && user?.role === 'member' && <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}><div className="spinner" /></div>}

      {/* Member Personalized View */}
      {user?.role === 'member' && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: 32, marginBottom: 40 }}>
          {/* Member Profile Data */}
          <Card style={{ padding: 40, background: 'white', border: '1px solid var(--sindhi-cream)', borderRadius: 32 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 24, fontWeight: 800, color: 'var(--sindhi-navy)' }}>
                {t('myProfile') || 'My Profile'}
              </h2>
              <div style={{ width: 40, height: 40, borderRadius: 12, background: 'var(--sindhi-ivory)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>👤</div>
            </div>
            {memberData ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {[
                  [t('fullName') || 'Full Name', memberData.full_name],
                  [t('literaryName') || 'Literary Name', memberData.literary_name || '—'],
                  [t('membershipStatus') || 'Membership Status', memberData.membership_status || '—'],
                  [t('joinDate') || 'Join Date', memberData.join_date || '—'],
                  [t('district') || 'District', memberData.districtId || '—'],
                ].map(([k, v]) => (
                  <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid var(--sindhi-cream)', fontSize: 14 }}>
                    <span style={{ color: 'var(--sindhi-text-muted)', fontWeight: 600 }}>{k}</span>
                    <span style={{ fontWeight: 800, color: 'var(--sindhi-navy)' }}>{v}</span>
                  </div>
                ))}
              </div>
            ) : (
              <p style={{ color: 'var(--sindhi-text-muted)' }}>{t('loadingProfile') || 'Loading profile data...'}</p>
            )}
          </Card>

          {/* Branch Activity */}
          <Card style={{ padding: 40, background: 'white', border: '1px solid var(--sindhi-cream)', borderRadius: 32 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 24, fontWeight: 800, color: 'var(--sindhi-navy)' }}>
                {t('branchActivity') || 'Branch Activity'}
              </h2>
              <div style={{ width: 40, height: 40, borderRadius: 12, background: 'var(--sindhi-ivory)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>📢</div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {branchEvents.length > 0 ? branchEvents.map(ev => (
                <div key={ev.id} style={{ padding: 16, background: 'var(--sindhi-ivory)', borderRadius: 16, border: '1px solid var(--sindhi-cream)' }}>
                  <div style={{ fontSize: 11, color: 'var(--sindhi-maroon)', fontWeight: 800, marginBottom: 4 }}>{ev.date}</div>
                  <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--sindhi-navy)' }}>{t.language === 'sindhi' ? (ev.titleSindhi || ev.title) : ev.title}</div>
                  <div style={{ fontSize: 12, color: 'var(--sindhi-text-muted)', marginTop: 4 }}>{ev.type} @ {ev.venue}</div>
                </div>
              )) : (
                <div style={{ textAlign: 'center', padding: 40, color: 'var(--sindhi-text-muted)' }}>
                  {t('noRecentActivity') || 'No recent activity for your branch.'}
                </div>
              )}
            </div>
          </Card>
        </div>
      )}

      {/* Quick Actions & System Info */}
      <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
      gap: 32
    }}>
        {!isMember && (
          <Card style={{
            padding: 40,
            background: 'white',
            border: '1px solid var(--sindhi-cream)',
            borderRadius: 24
          }}>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 32
          }}>
              <h2 style={{
              fontFamily: 'var(--font-display)',
              fontSize: 24,
              fontWeight: 800,
              color: 'var(--sindhi-navy)'
            }}>
                {t('quickActions')}
              </h2>
              <div style={{
              width: 40,
              height: 40,
              borderRadius: 12,
              background: 'var(--sindhi-ivory)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 18
            }}>⚡</div>
            </div>
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16
          }}>
              <QuickAction index={0} icon="👤" label={t('approveMembers')} to="/admin/members" />
              <QuickAction index={1} icon="📰" label={t('postNewsEvent')} to="/admin/events" />
              <QuickAction index={2} icon="📚" label={t('addBookJournal')} to="/admin/books" />
              <QuickAction index={3} icon="🏛️" label={t('addBoardMember')} to="/admin/board" />
              {isMain && <QuickAction index={4} icon="🌿" label={t('manageBranches')} to="/admin/branches" />}
            </div>
          </Card>
        )}

        <Card style={{
        padding: 40,
        background: 'white',
        border: '1px solid var(--sindhi-cream)',
        borderRadius: 24
      }}>
          <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 32
        }}>
            <h2 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 24,
            fontWeight: 800,
            color: 'var(--sindhi-navy)'
          }}>
              {t('systemInfo')}
            </h2>
            <div style={{
            width: 40,
            height: 40,
            borderRadius: 12,
            background: 'var(--sindhi-ivory)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 18
          }}>🛡️</div>
          </div>
          <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0
        }}>
            {[[t('role'), user?.role?.replace('_', ' ')], [t('status'), t('activeLabel')], [t('platform'), 'SAS v1.0 Premium'], [t('database'), DB_TYPE], [t('server'), t('runningLabel')]].map(([k, v], idx) => <div key={k} style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '18px 0',
            borderBottom: idx === 4 ? 'none' : '1px solid var(--sindhi-cream)',
            fontSize: 15
          }}>
                <span style={{
              color: 'var(--sindhi-text-muted)',
              fontWeight: 600
            }}>{k}</span>
                <span style={{
              fontWeight: 800,
              color: 'var(--sindhi-navy)',
              textTransform: 'capitalize',
              background: k === t('status') || k === t('database') || k === t('server') ? 'var(--sindhi-ivory)' : 'transparent',
              padding: k === t('status') || k === t('database') || k === t('server') ? '2px 10px' : '0',
              borderRadius: 6,
              fontSize: 13
            }}>{v}</span>
              </div>)}
          </div>
          <div style={{
          marginTop: 32,
          padding: 24,
          background: 'var(--sindhi-ivory)',
          borderRadius: 20,
          border: '1px solid var(--sindhi-cream)'
        }}>
            <div style={{
            fontSize: 12,
            color: 'var(--sindhi-text-muted)',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: 1,
            marginBottom: 8
          }}>{t('securityNote')}</div>
            <p style={{
            fontSize: 13,
            color: 'var(--sindhi-text)',
            lineHeight: 1.5,
            margin: 0
          }}>
              {t('secureSessionMsg')}
            </p>
          </div>
        </Card>
      </div>

      {/* Change Password Section */}
      <div style={{ marginTop: 32 }}>
        <Card style={{ 
          padding: 40, 
          background: 'white', 
          border: '1px solid var(--sindhi-cream)', 
          borderRadius: 24,
          maxWidth: 600
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 24, fontWeight: 800, color: 'var(--sindhi-navy)' }}>
              {t('changePassword')}
            </h2>
            <div style={{ width: 40, height: 40, borderRadius: 12, background: 'var(--sindhi-ivory)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>🔐</div>
          </div>
          
          <form onSubmit={async (e) => {
            e.preventDefault();
            const newP = e.target.newPassword.value;
            if (newP.length < 6) {
                toast.error(t('language') === 'sindhi' ? "پاسورڊ گھٽ ۾ گھٽ 6 اکرن جو ھجڻ گھرجي." : "Password must be at least 6 characters.");
                return;
            }
            try {
                await updatePassword(auth.currentUser, newP);
                toast.success(t('passwordUpdated'));
                e.target.reset();
            } catch (err) {
                if (err.code === 'auth/requires-recent-login') {
                    toast.error(t('language') === 'sindhi' ? "مهرباني ڪري ٻيهر لاگ ان ٿيو پاسورڊ تبديل ڪرڻ لاءِ." : "Please re-login to change your password.");
                } else {
                    toast.error(t('error'));
                }
            }
          }}>
            <div style={{ display: 'flex', gap: 16, alignItems: 'flex-end', flexWrap: 'wrap' }}>
              <div className="form-group" style={{ flex: 1, minWidth: 250, marginBottom: 0 }}>
                <label className="form-label">{t('newPassword')}</label>
                <input name="newPassword" type="password" className="form-input" placeholder="••••••••" required 
                  style={{ background: 'var(--sindhi-ivory)', border: '1px solid var(--sindhi-cream)' }} />
              </div>
              <button type="submit" className="btn btn-primary" style={{ padding: '14px 28px' }}>
                {t('updatePassword')}
              </button>
            </div>
          </form>
        </Card>
      </div>
    </div>;
}